import * as React from 'react';
import { Icon } from 'src/components/ui/icon';
import type { SidebarIcon } from 'src/layouts/SidebarV2/icons';
import { cn } from 'src/utils/utils';

export interface IconActionProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  icon: SidebarIcon;
  label: string;
  iconSize?: number;
  colorClass?: string;
}

const IconAction = React.forwardRef<HTMLButtonElement, IconActionProps>(
  (
    {
      icon,
      label,
      iconSize = 18,
      colorClass = 'tw:text-icon-primary-hover',
      className,
      onClick,
      ...props
    },
    ref
  ) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      // preventDefault stops the enclosing row's <a> navigation (stopPropagation alone won't).
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      className={cn(
        'tw:flex tw:items-center tw:justify-center tw:shrink-0 tw:cursor-pointer',
        'tw:border-0 tw:bg-transparent tw:rounded-s',
        'tw:transition-colors',
        className
      )}
      {...props}
    >
      <Icon icon={icon} size={iconSize} colorClass={colorClass} />
    </button>
  )
);

IconAction.displayName = 'IconAction';

export { IconAction };
